{
  "name": "@wayke-se/valuation-web",
  "version": "1.2.4-beta.1",
  "description": "Wayke Valuation Web, is an embeddable widget used to valuate a car based on Wayke Intelligent Pricing.",
  "module": "dist/index.mjs",
  "main": "dist/index.js",
  "types": "dist/index.d.ts",
  "type": "module",
  "scripts": {
    "start": "rimraf www/build && node ./esbuild/start.js",
    "build": "npm run clean && node ./esbuild/lib.js && node ./esbuild/cdn.js",
    "clean": "rimraf build && rimraf dist && rimraf dist-cdn",
    "test": "npm run lint && npm run typecheck",
    "typecheck": "tsc -noEmit",
    "typecheck:watch": "tsc -noEmit -watch",
    "lint": "eslint --ext .ts,.js 'src'",
    "lint:fix": "eslint --ext .ts,.js 'src' --fix",
    "stylelint": "stylelint '**/*.scss'",
    "prepare": "husky install",
    "clip": "node ./esbuild/clip-ui.js && node ./clip-ui/start.js"
  },
  "author": "Wayke",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/wayke-se/wayke-valuation-web/issues"
  },
  "homepage": "https://github.com/wayke-se/wayke-valuation-web#readme",
  "lint-staged": {
    "*.{js,ts}": [
      "eslint"
    ]
  },
  "devDependencies": {
    "@ourstudio/clip-ui": "^0.0.11",
    "@types/node": "^17.0.18",
    "@typescript-eslint/eslint-plugin": "^5.12.0",
    "@typescript-eslint/parser": "^5.12.0",
    "esbuild": "^0.19.4",
    "esbuild-sass-plugin": "^2.16.0",
    "eslint": "^8.9.0",
    "eslint-config-prettier": "^8.3.0",
    "eslint-plugin-prettier": "^4.0.0",
    "husky": "^8.0.1",
    "lint-staged": "^15.3.0",
    "npm-dts": "^1.3.11",
    "prettier": "^2.5.1",
    "rimraf": "^4.4.1",
    "stylelint": "^15.3.0",
    "stylelint-config-prettier-scss": "^0.0.1",
    "stylelint-config-standard-scss": "^7.0.1",
    "typescript": "^5.0.2"
  },
  "files": [
    "dist"
  ],
  "dependencies": {
    "i18next": "^22.4.13"
  }
}
